<div class="cookie-dialogue-content">
  <app-button
    secondary
    class="close-icon"
    [ignoreReadOnly]="true"
    [icon]="X_ICON"
    [aria]="{ label: GLOBAL_STRINGS.CLOSE | translateString }"
    (buttonClicked)="closeDialogue()"
  ></app-button>
  <h3 id="cookie-dialogue-heading" tabindex="-1" class="no-outline">
    {{ DIALOGUE_STRINGS.HEADING | translateString }}
  </h3>
  <p>{{ DIALOGUE_STRINGS.TEXT | translateString }}</p>
  <p>
    {{ DIALOGUE_STRINGS.COOKIE_NOTICE_TEXT | translateString }}
    <a href="/cookie-notice" target="_blank">{{ DIALOGUE_STRINGS.COOKIE_NOTICE | translateString }}</a
    >.
  </p>
  <fieldset class="inputs" aria-live="polite">
    <legend class="sr-only">
      {{ DIALOGUE_STRINGS.HEADING | translateString }}
    </legend>
    <div class="buttons">
      <app-button
        secondary
        [ignoreReadOnly]="true"
        (buttonClicked)="toggleOptions()"
        [aria]="{ expanded: isShowingOptions ? true : false, controls: 'cookie-dialogue-options' }"
        class="options-button"
      >
        {{ DIALOGUE_STRINGS.MANAGE_OPTIONS | translateString }}
      </app-button>
      <app-button [ignoreReadOnly]="true" (buttonClicked)="accept(true)" dataCy="accept-all-cookies">
        {{ DIALOGUE_STRINGS.ACCEPT_ALL | translateString }}</app-button
      >
    </div>
    <fieldset *ngIf="isShowingOptions" class="checkboxes" id="cookie-dialogue-options" tabindex="-1">
      <legend class="sr-only">
        {{ DIALOGUE_STRINGS.MANAGE_OPTIONS | translateString }}
      </legend>
      <app-input-checkbox
        [control]="cookieRequiredControl"
        [disabled]="true"
        [label]="DIALOGUE_STRINGS.REQUIRED | translateString"
      />
      <app-input-checkbox
        [control]="cookiePreferencesControl"
        [ignoreReadOnly]="true"
        [label]="DIALOGUE_STRINGS.PREFERENCES | translateString"
      />
      <app-input-checkbox
        [control]="cookiePerformanceControl"
        [ignoreReadOnly]="true"
        [label]="DIALOGUE_STRINGS.PERFORMANCE | translateString"
      />
      <app-button [ignoreReadOnly]="true" secondary (buttonClicked)="accept()" class="accept-button">
        {{ DIALOGUE_STRINGS.ONLY_SELECTED | translateString }}
      </app-button>
      <app-button [ignoreReadOnly]="true" secondary (buttonClicked)="deny()" class="deny-button">
        {{ DIALOGUE_STRINGS.DENY | translateString }}
      </app-button>
    </fieldset>
  </fieldset>
</div>
